import {
  FETCH_PROJECT_DATA,
  FETCH_PROJECT_DATA_TOTAL,
  FETCH_PROJECT_DATA_ERROR,
  FETCH_PROJECT_DATA_LOADING
} from "../constants";
import gql from "graphql-tag";
import client from "../apolloClient";

export function projectDataFetchData(
  fetchQuery = null,
  limit = 15,
  page = 1,
  searchValue = null
) {
  return (dispatch, getState) => {
    dispatch(projectDataIsLoading(true));
    let state = getState();
    let query;
    let where = {};

    if (fetchQuery) {
      query = fetchQuery;
    } else {
      switch (state.filterMode) {
        case "private":
          where.proj_owner = { _eq: state.user.id };
          break;
        case "team":
          // where.team = { id: { _eq: state.filterValue } };
          where._and = {
            team: { id: { _eq: state.filterValue } },
            proj_share: { _eq: -2 }
          };
          break;
        case "shared":
          where._and = {
            team: { id: { _eq: state.filterValue } },
            share_user: { _contains: [state.user.id] }
            // proj_share: { _eq: state.user.id }
          };
          break;
        default:
      }

      if (searchValue) {
        where.proj_name = { _ilike: `%${searchValue}%` };
      }

      query = gql`
        query getProjects($where: simcaa_t_projects_bool_exp) {
          simcaa_t_projects(where: $where, limit: ${limit}, offset: ${(page -
        1) *
        limit}, order_by: {created_at: desc}) {
            id
            proj_name
            proj_owner
            proj_share
            proj_profile
            proj_layout
            proj_blocked
            proj_note
            updated_at
            share_user
            team {
              name
              id
            }
            user {
              user
            }
          }
          simcaa_t_projects_aggregate(where: $where) {
            aggregate {
              count
            }
          }
        }
      `;
    }

    client
      .query({ query, variables: { where } })
      .then(data => {
        let finalData = data.data.simcaa_t_projects;
        finalData = finalData.map(item => {
          const { user, team, id, ...props } = item;
          return {
            proj_id: id,
            user_name: user ? user.user : "",
            team_id: team.id,
            team_name: team.name,
            ...props
          };
        });

        dispatch(projectDataIsLoading(false));
        if (data.networkStatus !== 7) {
          dispatch(projectDataHasErrored(true));
        } else {
          dispatch(projectDataFetchDataSuccess(finalData));
          dispatch(
            projectDataFetchDataTotal(
              data.data.simcaa_t_projects_aggregate.aggregate.count
            )
          );
          dispatch(projectDataHasErrored(false));
        }
      })
      .catch(error => {
        dispatch(projectDataHasErrored(true));
        dispatch(projectDataIsLoading(false));
      });
  };
}

export function projectDataCreateData(mutationQuery, data) {
  return dispatch => {
    dispatch(projectDataIsLoading(true));

    client
      .mutate({ mutation: mutationQuery, variables: { objects: [data] } })
      .then(data => {
        dispatch(projectDataIsLoading(false));
        if (data.data) {
          dispatch(projectDataHasErrored(false));
          dispatch(projectDataFetchData());
        } else {
          dispatch(projectDataHasErrored(true));
        }
      })
      .catch(error => {
        dispatch(projectDataIsLoading(false));
        dispatch(projectDataHasErrored(true));
      });
  };
}

export function projectDataUpdateData(mutationQuery, variables = {}, cb = () => {}, reFetch = true) {
  return dispatch => {
    dispatch(projectDataIsLoading(true));

    client
      .mutate({ mutation: mutationQuery, variables })
      .then(data => {
        dispatch(projectDataIsLoading(false));
        if (data.data) {
          dispatch(projectDataHasErrored(false));
          if (reFetch) {
            dispatch(projectDataFetchData());
          }
          cb()
        } else {
          dispatch(projectDataHasErrored(true));
        }
      })
      .catch(error => {
        dispatch(projectDataIsLoading(false));
        dispatch(projectDataHasErrored(true));
      });
  };
}

export function projectDataDeleteChapterData(id, deleteProject = false) {
  return dispatch => {
    dispatch(projectDataIsLoading(true));

    let query = gql`
      mutation deleteProjectChapters {
        delete_simcaa_t_projects_chapt(where: {caa_project_id: {_eq: ${id}}}) {
          affected_rows
        }
      }
    `;

    client
      .mutate({ mutation: query })
      .then(data => {
        dispatch(projectDataIsLoading(false));
        if (data.data) {
          dispatch(projectDataHasErrored(false));
          if (deleteProject === true) {
            dispatch(projectDataDeleteData(id));
          }
        } else {
          dispatch(projectDataHasErrored(true));
        }
      })
      .catch(error => {
        dispatch(projectDataIsLoading(false));
      });
  };
}

export function projectDataDeleteData(id) {
  return dispatch => {
    dispatch(projectDataIsLoading(true));
    let query = gql`
      mutation deleteProject {
        delete_simcaa_t_projects(where: { id: { _eq: ${id} } }) {
          affected_rows
        }
      }
    `;

    client
      .mutate({ mutation: query })
      .then(data => {
        if (data.data) {
          let myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");

          let body = JSON.stringify({"folder": `images/${id}`, "multiple": true});

          let requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body,
            redirect: 'follow'
          };

          fetch(window.env.DeleteFile, requestOptions)
            .then(response => response.json())
            .then(result => {
              dispatch(projectDataHasErrored(false));
              dispatch(projectDataFetchData());
            })
        } else {
          dispatch(projectDataIsLoading(false));
          dispatch(projectDataHasErrored(true));
        }
      })
      .catch(error => {
        dispatch(projectDataIsLoading(false));
        dispatch(projectDataHasErrored(true));
      });
  };
}

// Duplicate the current project
export function duplicateProject(project) {
  return (dispatch, getState) => {
    // let proj_share = project.proj_share >= 0 ? -1 : project.proj_share;
    let proj_share = -1;

    const query = gql`
      {
        simcaa_t_projects_chapt(where: {caa_project_id: {_eq: ${project.proj_id}}}) {
          id
          chapt_title
          caa_project_id
          typo {
            chapt_typo_card
            chapt_typo_imgex
            chapt_typo_text
            chapt_typo_draw
            chapt_typo_profile
          }
          content {
            chapt_content
          }
          row {
            chapt_row
          }
          content_alt {
            chapt_image_alt
          }
        }
      }
    `;

    client.query({ query }).then(data => {
      const chaptData = data.data.simcaa_t_projects_chapt.map(chapt => {
        delete chapt.typo[0].__typename
        delete chapt.content[0].__typename
        delete chapt.content_alt[0].__typename
        delete chapt.row[0].__typename
        return {
          chapt_title: `${chapt.chapt_title}`,
          chapt_user_block: 0,
          typo: { data: chapt.typo[0] },
          content: { data: chapt.content[0] },
          row: { data: chapt.row[0] },
          content_alt: { data: chapt.content_alt[0] },
        };

        // const { id, __typename, caa_project_id, ...props } = chapt;
        // return {
        //   ...props,
        //   chapt_user_block: 0
        // };
      });

      const newData = {
        proj_name: `copia_di_${project.proj_name}`,
        proj_owner: getState().user.id,
        proj_share,
        proj_profile: project.proj_profile,
        proj_blocked: 0,
        proj_team: getState().filterValue,
        proj_note: project.proj_note,
        chapters: { data: chaptData }
      };

      const mutation = gql`
        mutation duplicateProject(
          $objects: [simcaa_t_projects_insert_input!]!
        ) {
          insert_simcaa_t_projects(objects: $objects) {
            affected_rows
          }
        }
      `;

      dispatch(projectDataCreateData(mutation, newData));
    });
  };
}

// Lock/unlock project
export function lockUnlockProject(id, value) {
  return dispatch => {
    dispatch(projectDataIsLoading(true));
    let query = gql`
      mutation lockProject {
        update_simcaa_t_projects(where: {id: {_eq: ${id}}}, _set: {proj_blocked: ${value}}) {
          affected_rows
        }
      }
    `;

    client
      .mutate({ mutation: query })
      .then(data => {
        if (data.data) {
          dispatch(projectDataHasErrored(false));
          dispatch(projectDataFetchData());
        } else {
          dispatch(projectDataIsLoading(false));
          dispatch(projectDataHasErrored(true));
        }
      })
      .catch(error => {
        dispatch(projectDataIsLoading(false));
        dispatch(projectDataHasErrored(true));
      });
  };
}

export function projectDataHasErrored(bool) {
  return {
    type: FETCH_PROJECT_DATA_ERROR,
    hasErrored: bool
  };
}

export function projectDataIsLoading(bool) {
  return {
    type: FETCH_PROJECT_DATA_LOADING,
    isLoading: bool
  };
}

export function projectDataFetchDataSuccess(projectData) {
  return {
    type: FETCH_PROJECT_DATA,
    project: projectData
  };
}

export function projectDataFetchDataTotal(total) {
  return {
    type: FETCH_PROJECT_DATA_TOTAL,
    total
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/ProjectFetchActions.js